<template>
  <v-card>
    <v-toolbar :color="color" dark>
      <v-icon class="mr-3">{{ icon }}</v-icon>
      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn small fab color="error" @click="close()">
        <v-icon small>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-container class="mt-3">
        <slot name="content-dialog"></slot>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <slot name="action-dialog"></slot>
    </v-card-actions>
    <v-progress-linear
      :active="loading"
      :indeterminate="loading"
      absolute
      bottom
      :color="color"
    ></v-progress-linear>
  </v-card>
</template>

<script>
export default {
  name: "SDialog",
  props: {
    color: {
      type: String,
      default: "primaryColor",
    },
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    close() {
      return this.$emit("onClose");
    },
  },
};
</script>

<style></style>
